import { ContentCard } from 'ypf-pas-general-ui-components';
import { BsChatRightText } from 'react-icons/bs';
import './NoComments.scss';

const NoComments = () => (
  <div className="no-comments-container">
    <ContentCard className="icon-container" orientation="horizontal">
      <BsChatRightText />
    </ContentCard>
    <p>
      <strong>No disponés de ningún comentario</strong>
    </p>
  </div>
);

export default NoComments;
